import { render, staticRenderFns } from "./modalCover.vue?vue&type=template&id=aa209024&scoped=true"
import script from "./modalCover.vue?vue&type=script&lang=js"
export * from "./modalCover.vue?vue&type=script&lang=js"
import style0 from "./modalCover.vue?vue&type=style&index=0&id=aa209024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa209024",
  null
  
)

export default component.exports